import { render } from "./TeamsView.vue?vue&type=template&id=6e7b491d&scoped=true"
import script from "./TeamsView.vue?vue&type=script&lang=js"
export * from "./TeamsView.vue?vue&type=script&lang=js"

import "./TeamsView.vue?vue&type=style&index=0&id=6e7b491d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7b491d"]])

export default __exports__